<app-reactive-select-input
  *ngIf="abstractControls.classification$ | async as classificationObserve"
  [isInline]="isInline"
  [filedLabel]="classificationObserve?.title"
  [fieldId]="'inputGroupClassification'"
  [control]="control"
  [keyOptions]="keyValueOptions"
>
</app-reactive-select-input>
